import { Nullable } from 'legacy/lut/classes/models/utils'
import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getDemoUnitsInputLabelTranslation } from '../../helpers/getDemoUnitsInputLabelTranslation'

import styles from './DemoUnitsReadMode.module.scss'

interface IDemoUnitsReadModeProps {
  demoUnits: Nullable<number>
  isRetail?: boolean
  isDistributor?: boolean
}

export const DemoUnitsReadMode: FC<IDemoUnitsReadModeProps> = ({
  demoUnits,
  isRetail,
  isDistributor,
}) => {
  const demoUnitsFieldLabelTranslation = useMemo(
    () =>
      getDemoUnitsInputLabelTranslation({
        isRetail,
        isDistributor,
      }),
    [isRetail, isDistributor]
  )

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{demoUnits || '-'}</div>
        <div className={styles.label}>
          <Translation text={demoUnitsFieldLabelTranslation} span />
        </div>
      </div>
    </div>
  )
}
